import { CDN_PSPDFKIT_BASE_URL } from './constants';

/* Preloading pspdfkit dependencies: start */
export const PSPDFKIT_PREFETCH_LINKS = [
  'chunk-standalone-server-eefede1c9792f417.js',
  'chunk-standalone-20dbb21ca1b71ad7.js',
  'chunk-core-worker-03b1d838c9d81b9b.js',
  'nutrient-viewer-206cfd18aec89db9.wasm',
  'nutrient-viewer-4166d50b2ca4755b.wasm.js'
];

export const PSPDFKIT_CUSTOM_PRELOAD_LINKS = PSPDFKIT_PREFETCH_LINKS.filter(fileName => fileName.includes('.wasm'));

/* Preloading pspdfkit dependencies: end */

export const getPSPDFKitAssetUrl = (fileName: string) => `${CDN_PSPDFKIT_BASE_URL}nutrient-viewer-lib/${fileName}`;

export const prefetchPSPDFKitWasmFiles = () => {
  PSPDFKIT_CUSTOM_PRELOAD_LINKS.forEach(asset => fetch(getPSPDFKitAssetUrl(asset)));
};
